import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  InputAdornment,
  Divider,
  Button,
  Typography,
  Grid,
  FormControlLabel,
  RadioGroup,
  Radio,
  Paper,
  TextField,
  TableRow,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableBody,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PerfectScrollbar from "react-perfect-scrollbar";
import clsx from "clsx";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { appService } from "../../App/app.service";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Skeleton from "@material-ui/lab/Skeleton";
import { styles } from "../NewFunnel/FunnelStyles";
import Loading from "../../components/Loading";
import * as d3 from "d3";
import NumberFormat from "react-number-format";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import {
  _isNaN,
  getDefaultSelectedFiscalQuarters,
  getDefaultACV,
  getDefaultSalesType,
} from "../../util/customFunctions";
import Drilldown from "../../components/Drilldown/DrilldownNew";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import ExpectedAcvPage from "../NewWaterFall/ExpectedAcvPage";
import addHeaderdescription from "../../components/HeaderDescription";
import LocationRangeFilter from "../../components/LocationRangeFilter";
import TeamFilterHierarchy from "../../components/team-filter-hirarchy";
import DataTable from "./DataTable";
// import DataTable from "./DataTable";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "15rem",
    fontSize: "1rem",
    color: "black",
    textAlign: "center",
    background: "white",
    border: "0.5px solid lightgrey",
  },
});

class MQLandHandRaisers extends React.Component {
  state = {
    Closed_Year_Month: ["All"],
    Opportunity_Record_Type: ["All"],
    Record_Type_Name__c: ["All"],
    Type: ["All"],
    closed_year: ["All"],
    closed_month: ["All"],
    quarter: ["All"],
    rep: ["All"],
    closed_fiscal_quarter: ["All"],
    Cust_Type: ["All"],
    region: ["All"],
    Booking_Type_NL_CS_US: ["All"],
    Acct_Industry: ["All"],
    Acct_Vertical: ["All"],
    Lead_Source: ["All"],
    Opp_Created_By: ["All"],
    Solution_Cat: ["All"],
    custType: ["All"],
    deal_category__c: ["All"],
    cross_sell1__c: ["All"],
    Acct_Segment: ["All"],
    Acct_Size_Segment: ["All"],
    team: ["All"],
    timeFrame: "quarter",
    disabled: [],
    acvPreset: "All",
    acv: 0,
    acvlt: 0,
    displayacv: 0,
    acvRadio: "preset",
    acvError: "",
    location: "overview",
    defaultColDef: {
      flex: 1,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      sortable: true,
      resizable: true,
    },
    selectedDrilldownStage: "",
    lastStage: false,
    activeFilters: ["All"],

    filtersForDrilldown: [],
    repFilter: ["All"],
    teamFilter: ["All"],
    xAxis: "",
    yAxis: "",
    xLabel: "",
    yLabel: "",
    xAxisError: "",
    yAxisError: "",
    toggleValue: "AcvSort",
    Earliest_Lost_Stage: [],
    Stage: [],

    Product_Line: ["All"],
    defaultACV: "",
    Of_Locations_Range: ["All"],
    Region__c: ["All"],
    Channel_Type__c: ["All"],
    Opportunity_Source_Channel__c: ["All"],
    Acct_Emp_Range: ["All"],
    Acct_Type: ["All"],
    Transaction_Type__c: ['All'],
    Acct_Industry_Subindustry: ['All'],
    fiscal_quarter: ['All'],
    drilldownFilters: [],
    MQL_Fiscal_Quarter: ['All'],
    Created_Fiscal_Quarter: ['All'],
    MQL_Calendar_Year_Month: ['All'],
    Created_Year_Month: ['All'],
    Exclude_LeadSource: ['All'],
    Qualification_Type__c: ['All'],
    Internal_Torq_Record__c: ['False'],
    Most_Recent_Campaign__c_Name: ['All'],
    Region2__c: ['All'],
    Territory__c: ['All'],
    tab: 'MQL',
    Most_Recent_Campaign__Does_Not_Contain: ['All']
  };

  filters = [
    "MQL_Fiscal_Quarter",
    "Created_Fiscal_Quarter",
    "MQL_Calendar_Year_Month",
    "Created_Year_Month",
    "Closed_Year_Month",
    "closed_year",
    "closed_month",
    "quarter",
    "rep",
    "closed_fiscal_quarter",
    "team",
    "Cust_Type",
    "Acct_Industry",
    "Acct_Vertical",
    "custType",
    "Booking_Type_NL_CS_US",
    "Acct_Size_Segment",
    "Acct_Segment",
    "Lead_Source",
    "Opp_Created_By",
    "Solution_Cat",
    "region",
    "deal_category__c",
    "cross_sell1__c",
    "Type",
    "Product_Line",
    "Opportunity_Record_Type",
    "Record_Type_Name__c",
    "Of_Locations_Range",
    "Opportunity_Source_Channel__c",
    "Region__c",
    "Channel_Type__c",
    "Acct_Emp_Range",
    "Acct_Type",
    "Transaction_Type__c",
    "Acct_Industry_Subindustry",
    "fiscal_quarter",
    "Exclude_LeadSource",
    "Qualification_Type__c",
    "Internal_Torq_Record__c",
    "Most_Recent_Campaign__c_Name",
    "Region2__c",
    "Territory__c",
    "Most_Recent_Campaign__Does_Not_Contain"
  ];

  months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  staticCustSegment = [
    { value: "<=$25M", displayValue: "<=$25M" },
    { value: "$25-50M", displayValue: "$25M-50M" },
    { value: "$50-250M", displayValue: "$50M-250M" },
    { value: "$250-500M", displayValue: "$250M-500M" },
    { value: "$500M-2B", displayValue: "$500M-2B" },
    { value: ">$2B", displayValue: ">$2B" },
  ];

  componentDidMount() {
    this.props.getFunnelFilters(this.props.company);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.funnelFilters !== "" && prevProps.funnelFilters === "") {
      const defaultFQuarter =  this.props.funnelFilters.defaultFiscalQuarter
      let deafaultLeadSource = ['All']
      let deafaultLeadSourceFilter = []
      if(this.props.funnelFilters.deafaultExclude_LeadSource && this.props.funnelFilters.deafaultExclude_LeadSource.length > 0){
        deafaultLeadSource = this.props.funnelFilters.deafaultExclude_LeadSource
        deafaultLeadSourceFilter = [{
            name: 'Exclude_LeadSource',
            value: deafaultLeadSource
        }]
      } 

      var defaultQuarter =
        defaultFQuarter.length > 0 ? defaultFQuarter : ["All"];
      var salesTypes = ["All"];
      var dealsTypes = ["All"];
      let solutioncat = ["All"];
      let custType = ['All']

      dealsTypes = getDefaultSalesType(
        this.props.funnelFilters.oppTypeFilter,
        "Type"
      );
      solutioncat = getDefaultSalesType(
        this.props.funnelFilters.solutionCat,
        "Solution_Cat"
      );
      if (this.props.company === "C0008") {
        salesTypes = getDefaultSalesType(
          this.props.funnelFilters.salesType,
          "cross_sell1__c"
        );
        dealsTypes = getDefaultSalesType(
          this.props.funnelFilters.dealType,
          "Type"
        );
      }

      let defaultCustTypeDrilldown = []
      let defaultCustTypeFilter = []
      if(this.props.company === 'C0020'){
        custType = this.props.funnelFilters.default_Cust_Type
        defaultCustTypeFilter = [{
            name: 'Cust_Type',
            value: custType
        }]
        defaultCustTypeDrilldown = [{
            title: 'Customer Type',
            value: custType
          }]
    }

    let dfi = 'False'
    if(this.props.funnelFilters.defaultInternal_Torq_Record__c){
        dfi = this.props.funnelFilters.defaultInternal_Torq_Record__c
    }

    let defaultMost_Recent_Campaign_Does_Not_Contain = ['All']

    if(this.props.funnelFilters.defaultMost_Recent_Campaign_Does_Not_Contain.length > 0){
        defaultMost_Recent_Campaign_Does_Not_Contain = this.props.funnelFilters.defaultMost_Recent_Campaign_Does_Not_Contain
    }


    //   let defaultvalueTeam;
    //   if (this.props.funnelFilters !== "") {
    //     const val = this.props.funnelFilters.parentChildrenTeamFilter;
    //     defaultvalueTeam = val.defaultValueTeam;
    //   }
      this.setState({
        ...prevState,
        MQL_Fiscal_Quarter: defaultQuarter,
        cross_sell1__c: salesTypes,
        Type: dealsTypes,
        Solution_Cat: solutioncat,
        Cust_Type: custType,
        Exclude_LeadSource: deafaultLeadSource,
        Most_Recent_Campaign__Does_Not_Contain: defaultMost_Recent_Campaign_Does_Not_Contain,
        Internal_Torq_Record__c: dfi,
        filtersForDrilldown: [
            ...defaultCustTypeDrilldown,
          {
            title: "MQL Fiscal Qtr.",
            value: defaultQuarter,
          },
          {
            title: 'Lead Sources Excluded',
            value: deafaultLeadSource
          },{
            title: 'Internal Torq Record',
            value: dfi
          },
          {
            title: `Most Recent Campaign doesn't contain`,
            value: defaultMost_Recent_Campaign_Does_Not_Contain
          }
        ],
        activeFilters: [
            ...defaultCustTypeFilter,
            ...deafaultLeadSourceFilter,
          { name: "MQL_Fiscal_Quarter", value: defaultQuarter },
          {
            name: 'Internal_Torq_Record__c',
            value: dfi
          },
          {
            name: 'Most_Recent_Campaign__Does_Not_Contain',
            value: defaultMost_Recent_Campaign_Does_Not_Contain
          }
        ],
      });
    }
  }

  handleChange = (e) => {
    if (
      e.target.name === "closed_year" &&
      e.target.value.filter((v) => v === "All").length > 0
    ) {
      this.setState({
        ...this.state,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
        closed_month: ["All"],
        quarter: ["All"],
      });
    } else if (typeof e.target.value === "string") {
      this.setState({
        ...this.state,
        [e.target.name]: [e.target.value],
      });
    } else {
      this.setState({
        ...this.state,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
      });
    }
  };

  handleChangeNew = (filteredValues) => {
    this.setState({
      ...this.state,
      team:
        this.state.team.length === 1 && this.state.team.includes("All")
          ? filteredValues.filter((v) => v !== "All").length > 0
            ? filteredValues.filter((v) => v !== "All")
            : ["All"]
          : filteredValues.includes("All")
          ? ["All"]
          : filteredValues,
    });
  };

  handleGo = () => {
    localStorage.removeItem("skygeni-auto-update");
    console.log(this.state.Earliest_Lost_Stage, "Earliest_Lost_Stage");
    let filters = this.filters
      .map((f) => {
        return {
          name: f,
          value:
            f === "rep"
              ? this.state[f].includes("All")
                ? this.state[f]
                : this.state[f].map(
                    (s) =>
                      this.props.funnelFilters.reps.filter(
                        (r) => r.Full_Name === s
                      )[0].UserID
                  )
              : f === "team"
              ? this.state[f].includes("All")
                ? this.state[f]
                : this.state[f].map(
                    (s) =>
                      this.props.funnelFilters.teams.filter(
                        (r) => r.Display_Name === s
                      )[0].Display_Name
                  )
              : this.state[f],
        };
      })
      .filter(
        (f) =>
          (!Array.isArray(f.value) && f.value !== "All") ||
          !f.value.includes("All")
      )
      .filter((f) => !this.state.disabled.includes(f.name));


      filters = [...filters, {name: 'MQL_Hand_Raisers_Tab', value: [this.state.tab]}]
    this.props.getFunnelDataNew(filters);
    this.setState({
      ...this.state,
      activeFilters: filters,
      filtersForDrilldown: this.passFiltersForDrilldown(),
      repFilter: this.state.rep,
      teamFilter: this.state.team,
    //   Stage: this.state.Earliest_Lost_Stage,
    });
  };

  orderRepsByLastName = () => {
    let reps = this.props.funnelFilters.reps
      .map((r) => r.Full_Name)
      .map((rep) => {
        const res = rep.split(" ", 2);
        return {
          firstName: res[0],
          lastName: res[1],
          fullName: rep,
          sortName: `${res[0]} ${res[1]}`,
        };
      });
    function compare(a, b) {
      if (a.sortName < b.sortName) {
        return -1;
      }
      if (a.sortName > b.sortName) {
        return 1;
      }
      return 0;
    }
    reps.sort(compare);
    reps = [
      { firstName: "All", lastName: "All", fullName: "All", sortName: "All" },
      ...reps,
    ];
    const menuItems = reps.map((rep, index) => {
      return rep.fullName;
    });
    return menuItems;
  };

  handleChangeTimeFrame = (e) => {
    this.setState({
      ...this.state,
      timeFrame: e.target.value,
      disabled:
        e.target.value === "custom"
          ? [
              ...this.state.disabled.filter(
                (f) =>
                  f !== "closed_year" && f !== "closed_month" && f !== "quarter"
              ),
              "closed_fiscal_quarter",
            ]
          : [
              ...this.state.disabled.filter(
                (f) => f !== "closed_fiscal_quarter"
              ),
              "closed_year",
              "closed_month",
              "quarter",
            ],
    });
  };

  handleChangeLocation = (location, obj, type, region, territory) => {
    console.log(obj);
    if (location !== "overview") {
     

      
      var filters = this.state.activeFilters


      let filtersForDrilldown = [...this.state.filtersForDrilldown]

       filters = [...filters, {
        name: obj.timeFrameType,
            value: typeof obj.cell === 'string' ? [obj.cell] : obj.cell
       }]
      

      if(type === 'Region2__c'){
        filtersForDrilldown = [...filtersForDrilldown ,{
            title: 'Region',
            value: obj.row === 'Total' ? ['All'] : obj.row
        }]
        filters = [...filters, {
            name: 'Region2__c',
                value: typeof obj.row === 'string' ? [obj.row] : obj.row
           }]

           if(territory.length > 0){

               filters = [...filters, {
                name: 'Territory__c',
                    value: typeof territory === 'string' ? [territory] : territory
               }]
           }
      }

      if(type === 'Territory__c'){
        filtersForDrilldown = [...filtersForDrilldown ,{
            title: 'Territory',
            value: obj.row === 'Total' ? ['All'] : obj.row
        }]

        filtersForDrilldown = [...filtersForDrilldown ,{
            title: 'Region',
            value: region === 'Total' ? ['All'] : region
        }]

        filters = [...filters, {
            name: 'Territory__c',
            value: obj.row === 'Total' ? ['All'] : obj.row},{
            name: 'Region2__c',
                value: typeof region === 'string' ? [region] : region
           }]
      }
   

  
    
      this.setState({
        ...this.state,
        location: location,
        secondLevelLocation: location,
        header:
          this.state.tab === "MQL"
            ? "By MQL"
            : `By Hand Raisers`,
            drilldownFilters: [...filtersForDrilldown],
      });
      
        this.props.getPipelineMixDrilldown(filters)
     
      
    } else {
      this.props.clearDrilldownData();
    }
  };

  passFiltersForDrilldown = () => {
    let filtersArray = [];
    if (!this.state.fiscal_quarter.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Fiscal Qtr.",
          value: this.state.fiscal_quarter.sort(),
        },
      ];
    }
    if (!this.state.Channel_Type__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Channel Type",
          value: this.state.Channel_Type__c.sort(),
        },
      ];
    }
    
    if (!this.state.Acct_Industry_Subindustry.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Industry + SubIndustry",
          value: this.state.Acct_Industry_Subindustry.sort(),
        },
      ];
    }
    if (!this.state.Opportunity_Source_Channel__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Opp Source Channel",
          value: this.state.Opportunity_Source_Channel__c.sort(),
        },
      ];
    }
    if (!this.state.Region__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Region",
          value: this.state.Region__c.sort(),
        },
      ];
    }
    if (!this.state.Acct_Emp_Range.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Account Emp. Range",
          value: this.state.Acct_Emp_Range.sort(),
        },
      ];
    }
    if (!this.state.Acct_Type.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Account Type",
          value: this.state.Acct_Type.sort(),
        },
      ];
    }

    if (!this.state.Transaction_Type__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Transaction Type",
          value: this.state.Transaction_Type__c.sort(),
        },
      ];
    }

    if (!this.state.Closed_Year_Month.includes("All")) {
      filtersArray = [
        ...filtersArray,
        { title: "Closed Month", value: this.state.Closed_Year_Month.sort() },
      ];
    }

    if (!this.state.Created_Fiscal_Quarter.includes("All")) {
        filtersArray = [
          ...filtersArray,
          { title: "Created Fiscal Quarter", value: this.state.Created_Fiscal_Quarter.sort() },
        ];
      }

      if (!this.state.Created_Year_Month.includes("All")) {
        filtersArray = [
          ...filtersArray,
          { title: "Created Month", value: this.state.Created_Year_Month.sort() },
        ];
      }

      if (!this.state.MQL_Fiscal_Quarter.includes("All")) {
        filtersArray = [
          ...filtersArray,
          { title: "MQL Fiscal Quarter", value: this.state.MQL_Fiscal_Quarter.sort() },
        ];
      }

      if (!this.state.MQL_Calendar_Year_Month.includes("All")) {
        filtersArray = [
          ...filtersArray,
          { title: "MQL Month", value: this.state.MQL_Calendar_Year_Month.sort() },
        ];
      }

    if (!this.state.closed_year.includes("All")) {
      filtersArray = [
        ...filtersArray,
        { title: "Closed Calendar Year", value: this.state.closed_year.sort() },
      ];
    }
    if (!this.state.closed_month.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Closed Calendar Month",
          value: this.state.closed_month
            .sort((a, b) => (a < b ? -1 : 1))
            .map((i) => this.months[i - 1]),
        },
      ];
    }
    if (!this.state.rep.includes("All"))
      filtersArray = [...filtersArray, { title: "Rep", value: this.state.rep }];

    if (!this.state.team.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Team", value: this.state.team },
      ];

    if (!this.state.Booking_Type_NL_CS_US.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Opportunity Type", value: this.state.Booking_Type_NL_CS_US },
      ];

    if (!this.state.cross_sell1__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Sales Type", value: this.state.cross_sell1__c },
      ];

    if (
      this.state.acv !== null &&
      this.state.acv !== 0 &&
      this.state.acv !== ""
    )
      filtersArray = [
        ...filtersArray,
        {
          title: `${this.props.Value_Label} >=`,
          value:
            `${this.props.Currency_Symbol}` +
            d3.format(",")(
              this.state.acv && typeof this.state.acv === "string"
                ? this.state.acv.match(/,/g)
                  ? this.state.acv.match(/,/g).length === 1
                    ? parseInt(this.state.acv) * 1000
                    : this.state.acv.match(/,/g).length === 2
                    ? parseInt(this.state.acv) * 1000000
                    : parseInt(this.state.acv)
                  : parseInt(this.state.acv)
                : this.state.acv
            ),
        },
      ];

    if (this.state.acvlt !== null && this.state.acvlt !== 0)
      filtersArray = [
        ...filtersArray,
        {
          title: `${this.props.Value_Label} <=`,
          value:
            `${this.props.Currency_Symbol}` +
            d3.format(",")(
              this.state.acvlt && typeof this.state.acvlt === "string"
                ? this.state.acvlt.match(/,/g)
                  ? this.state.acvlt.match(/,/g).length === 1
                    ? parseInt(this.state.acvlt) * 1000
                    : this.state.acv.match(/,/g).length === 2
                    ? parseInt(this.state.acvlt) * 1000000
                    : parseInt(this.state.acvlt)
                  : parseInt(this.state.acvlt)
                : this.state.acvlt
            ),
        },
      ];

    // if (this.state.Earliest_Lost_Stage !== "")
    //   filtersArray = [
    //     ...filtersArray,
    //     { title: "Earliest Lost Stage", value: this.state.Earliest_Lost_Stage },
    //   ];

    if (
      !this.state.Acct_Industry.includes("All") ||
      !this.state.Acct_Vertical.includes("All")
    )
      filtersArray = [
        ...filtersArray,
        {
          title: this.props.company === "C0003" ? "Vertical" : "Industry",
          value:
            this.props.company === "C0003"
              ? this.state.Acct_Vertical
              : this.state.Acct_Industry,
        },
      ];
    if (!this.state.Acct_Size_Segment.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: "Customer Segment",
          value:
            this.props.company === "C0003"
              ? this.state.Acct_Industry
              : this.state.Acct_Size_Segment,
        },
      ];
    if (!this.state.Cust_Type.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: this.props.company === "C0003" ? "Region" : "Customer Type",
          value:
            this.props.company === "C0003"
              ? this.state.region
              : this.state.Cust_Type,
        },
      ];
    if (!this.state.Exclude_LeadSource.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Lead Sources Excluded", value: this.state.Exclude_LeadSource },
      ];
    if (!this.state.Opp_Created_By.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Opportunity Created By", value: this.state.Opp_Created_By },
      ];

    if (!this.state.deal_category__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Deal Category", value: this.state.deal_category__c },
      ];

    if (!this.state.Type.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: ["C0017","C0024"].includes(this.props.company) ? "Opp. Type" : "Deal Type",
          value: this.state.Type,
        },
      ];

      if (!this.state.Most_Recent_Campaign__c_Name.includes("All"))
        filtersArray = [
          ...filtersArray,
          { title: "Most Recent Campaign", value: this.state.Most_Recent_Campaign__c_Name },
        ];


      if (!this.state.Most_Recent_Campaign__Does_Not_Contain.includes("All"))
        filtersArray = [
          ...filtersArray,
          { title: "Most Recent Campaign doesn't contain", value: this.state.Most_Recent_Campaign__Does_Not_Contain },
        ];

        if (!this.state.Qualification_Type__c.includes("All"))
            filtersArray = [
              ...filtersArray,
              { title: "Qualification Type", value: this.state.Qualification_Type__c },
            ];

            if (!this.state.Internal_Torq_Record__c.includes("All"))
                filtersArray = [
                  ...filtersArray,
                  { title: "Internal Torq Record", value: this.state.Internal_Torq_Record__c },
                ];

    if (
      this.props.company !== "C0003" &&
      !this.state.Solution_Cat.includes("All")
    )
      filtersArray = [
        ...filtersArray,
        { title: "Solution Category", value: this.state.Solution_Cat },
      ];

    if (
      this.props.company === "C0013" &&
      !this.state.Opportunity_Record_Type.includes("All")
    )
      filtersArray = [
        ...filtersArray,
        {
          title: "Opportunity Record Type",
          value: this.state.Opportunity_Record_Type,
        },
      ];

    if (
      this.props.company === "C0010" &&
      !this.state.Record_Type_Name__c.includes("All")
    )
      filtersArray = [
        ...filtersArray,
        {
          title: "Opp Record Type",
          value: this.state.Record_Type_Name__c,
        },
      ];

    if (!this.state.Product_Line.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title:
            this.props.company === "C0008" ? "Product Line" : "Product Cat.",
          value: this.props.funnelFilters.Product_Line.filter((s) =>
            this.state.Product_Line.includes(s.Product_Line)
          ).map((item) => item.label),
        },
      ];

    return filtersArray;
  };

  onRepChange = (event, value) => {
    this.setState({
      ...this.state,
      rep: [value ? value : "All"],
    });
  };

  onInternalTroqueChage = (e) => {
    // console.log(e.target.value, 'nbhafgauduadugasyg')
    this.setState({
        ...this.state,
      Internal_Torq_Record__c: [e.target.value]
      });
  }

  onAcvChange = (event, value) => {
    this.setState({
      ...this.state,
      acv: value,
    });
  };
  onAcvLtChange = (event, value) => {
    this.setState({
      ...this.state,
      acvlt: value,
    });
  };
  xyAxisChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.name]: e.target.value,
      xAxisError:
        e.target.name === "xAxis"
          ? e.target.value === this.state.yAxis
            ? "Primary Dimesions and Secondary Dimeasions cannot be same"
            : ""
          : "",
      yAxisError:
        e.target.name === "yAxis"
          ? e.target.value === this.state.xAxis
            ? "Primary Dimesions and Secondary Dimeasions cannot be same"
            : ""
          : "",
    });
  };

  handleChangeLocationBack = (location) => {
    this.setState({
      ...this.state,
      location: "",
      secondLevelLocation: "",
      drilldownFilters: []
    });
  };

  handleChangeToggle = (e) => {
    this.setState({
      ...this.state,
      toggleValue: e.target.value,
    });
  };

  handleSecondLevelDrilldown = (location, oppId) => {
    console.log(oppId);
    this.setState({
      ...this.state,
      secondLevelLocation: location,
    });
    this.props.getOpenOppData(oppId);
  };

  stepBack = () => {
    this.setState({
      ...this.state,
      secondLevelLocation: "",
    });
    this.props.clearExpectedAcvData();
  };


  handleChangeTab = (e) => {
    const tabValue = e.target.value;
    console.log(tabValue);

    let deafaultLeadSource =  ['All']
    if(this.props.funnelFilters.deafaultExclude_LeadSource && this.props.funnelFilters.deafaultExclude_LeadSource.length > 0){
        deafaultLeadSource = this.props.funnelFilters.deafaultExclude_LeadSource
      } 

      let defaultQualificationType = ['All']
      if(this.props.funnelFilters.defaultQualification_Type__c && this.props.funnelFilters.defaultQualification_Type__c.length > 0){
        defaultQualificationType = this.props.funnelFilters.defaultQualification_Type__c
      } 
      
      const leadSource = tabValue === 'MQL' ? deafaultLeadSource : ['All']
      const qt = tabValue === 'Hand_Raisers' ? defaultQualificationType : ['All']
      console.log(defaultQualificationType, qt, 'adshfgadshugfuagdfuyg');
    // Directly updating the tab state
    this.setState({ tab: tabValue, Exclude_LeadSource: leadSource, Qualification_Type__c: qt }, () => {
      // Ensure that the handleGo() method runs after the state has been updated
      this.handleGo();
    });
  };


  render() {
    const { classes } = this.props;

    let teamObject;
    if (this.props.funnelFilters !== "") {
      teamObject = this.props.funnelFilters.parentChildrenTeamFilter;
    }

    return (
      <Grid container style={{ position: "relative" }}>
        {addHeaderdescription(
          "MQL and Hand Raisers Analysis ",
          "MQL and Hand Raisers Analysis "
        )}

        {this.props.funnelFilters ? (
          <>
            {/* dates */}
            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={12}
              md={4}
            >
              <Grid item spacing={2} xs={12} container component={Paper}>
                <Grid item xs={6} sm={6}>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    disabled={
                      this.state.MQL_Calendar_Year_Month[0] !== "All" 
                    }
                  >
                    <InputLabel
                      id="select-fiscalQuarter-label"
                      style={{
                        color: !this.state.MQL_Fiscal_Quarter.includes("All")
                          ? "#4472c4"
                          : "#000",
                      }}
                    >
                      MQL Fiscal Qtr.:
                    </InputLabel>
                    <Select
                      data-test="closed-fiscal-quarter"
                      labelId="select-fiscalQuarter-label"
                      id="select-fiscalQuarter"
                      value={this.state.MQL_Fiscal_Quarter}
                      onChange={this.handleChange}
                      label="MQL Fiscal Qtr."
                      name="MQL_Fiscal_Quarter"
                      multiple
                    >
                      <MenuItem value={"All"}>All</MenuItem>
                      {this.props.funnelFilters !== "" &&
                        this.props.funnelFilters.MQL_Fiscal_Quarter
                          .filter((item) => item !== "")
                          .map((y) => (
                            <MenuItem
                              key={y}
                              value={y}
                            >
                              {y}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Grid>
              
                <Grid item xs={6} sm={6} >
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    disabled={this.state.MQL_Fiscal_Quarter[0] !== "All"}
                  >
                    <InputLabel
                      id="select-year-label"
                      style={{
                        color: !this.state.MQL_Calendar_Year_Month.includes("All")
                          ? "#4472c4"
                          : "#000",
                      }}
                    >
                      MQL Calendar Month:
                    </InputLabel>
                    <Select
                      labelId="select-year-label"
                      id="select-year"
                      value={this.state.MQL_Calendar_Year_Month}
                      onChange={this.handleChange}
                      label="Year"
                      name="MQL_Calendar_Year_Month"
                      data-test="year"
                      multiple
                    >
                      <MenuItem value={"All"}>All</MenuItem>
                      {this.props.funnelFilters !== "" &&
                        this.props.funnelFilters.MQL_Calendar_Year_Month
                          .filter((item) => item !== "")
                          .map((y) => (
                            <MenuItem key={y} value={y}>
                              {y}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Grid>
                
              </Grid>
            </Grid>

            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={12}
              md={4}
            >
              <Grid item spacing={2} xs={12} container component={Paper}>
                <Grid item xs={6} sm={6}>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    disabled={
                      this.state.Created_Year_Month[0] !== "All" 
                    }
                  >
                    <InputLabel
                      id="select-fiscalQuarter-label"
                      style={{
                        color: !this.state.Created_Fiscal_Quarter.includes("All")
                          ? "#4472c4"
                          : "#000",
                      }}
                    >
                      Create Fiscal Qtr.:
                    </InputLabel>
                    <Select
                      data-test="closed-fiscal-quarter"
                      labelId="select-fiscalQuarter-label"
                      id="select-fiscalQuarter"
                      value={this.state.Created_Fiscal_Quarter}
                      onChange={this.handleChange}
                      label="Created Fiscal Qtr."
                      name="Created_Fiscal_Quarter"
                      multiple
                    >
                      <MenuItem value={"All"}>All</MenuItem>
                      {this.props.funnelFilters !== "" &&
                        this.props.funnelFilters.Created_Fiscal_Quarter
                          .filter((item) => item !== "")
                          .map((y) => (
                            <MenuItem
                              key={y}
                              value={y}
                            >
                              {y}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Grid>
              
                <Grid item xs={6} sm={6} >
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    disabled={this.state.Created_Fiscal_Quarter[0] !== "All"}
                  >
                    <InputLabel
                      id="select-year-label"
                      style={{
                        color: !this.state.Created_Year_Month.includes("All")
                          ? "#4472c4"
                          : "#000",
                      }}
                    >
                      Created Month:
                    </InputLabel>
                    <Select
                      labelId="select-year-label"
                      id="select-year"
                      value={this.state.Created_Year_Month}
                      onChange={this.handleChange}
                      label="Year"
                      name="Created_Year_Month"
                      data-test="year"
                      multiple
                    >
                      <MenuItem value={"All"}>All</MenuItem>
                      {this.props.funnelFilters !== "" &&
                        this.props.funnelFilters.Created_Year_Month
                          .filter((item) => item !== "")
                          .map((y) => (
                            <MenuItem key={y} value={y}>
                              {y}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Grid>
                
              </Grid>
            </Grid>

            {/* rep & team */}
         
            {/* Adding Acv Value */}
    



                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <Grid item spacing={2} xs={12} container component={Paper}>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state.Qualification_Type__c.includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-region-label"
                        >
                          Qualification Type:
                        </InputLabel>
                        <Select
                          data-test="Qualification_Type__c"
                          value={this.state.Qualification_Type__c}
                          onChange={this.handleChange}
                          name="Qualification_Type__c"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelFilters !== "" &&
                            this.props.funnelFilters.Qualification_Type__c.map((y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>


                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <Grid item spacing={2} xs={12} container component={Paper}>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: "#4472c4"
                              
                          }}
                          id="select-region-label"
                        >
                         Internal Torq Record:
                        </InputLabel>
                        <Select
                          data-test="Internal_Torq_Record__c"
                          value={this.state.Internal_Torq_Record__c[0]}
                          onChange={this.onInternalTroqueChage}
                          name="Internal_Torq_Record__c"
                          single
                        >
                          {this.props.funnelFilters !== "" &&
                            this.props.funnelFilters.Internal_Torq_Record__c.map((y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>






                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <Grid item spacing={2} xs={12} container component={Paper}>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state.Region2__c.includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-region-label"
                        >
                         Region:
                        </InputLabel>
                        <Select
                          data-test="Region2__c"
                          value={this.state.Region2__c}
                          onChange={this.handleChange}
                          name="Region2__c"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelFilters !== "" &&
                            this.props.funnelFilters.Region2__c.map((y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>



                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <Grid item spacing={2} xs={12} container component={Paper}>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state.Territory__c.includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-region-label"
                        >
                         Territory:
                        </InputLabel>
                        <Select
                          data-test="Territory__c"
                          value={this.state.Territory__c}
                          onChange={this.handleChange}
                          name="Territory__c"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelFilters !== "" &&
                            this.props.funnelFilters.Territory__c.map((y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                
                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <Grid item spacing={2} xs={12} container component={Paper}>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state.Exclude_LeadSource.includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-region-label"
                        >
                         Lead Sources Excluded:
                        </InputLabel>
                        <Select
                          data-test="Exclude_LeadSource"
                          value={this.state.Exclude_LeadSource}
                          onChange={this.handleChange}
                          name="Exclude_LeadSource"
                          multiple
                        >
                          <MenuItem value={"All"}>None</MenuItem>
                          {this.props.funnelFilters !== "" &&
                            this.props.funnelFilters.Exclude_LeadSource.map((y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>


   <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15,   maxWidth: '350px' }}
                  xs={3}
                >
                  <Grid item spacing={2} xs={12} container component={Paper}>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth className={classes.formControl}
                      style={{  maxWidth: '350px'}}
                      >
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state.Most_Recent_Campaign__Does_Not_Contain.includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-region-label"
                        >
                         Most Recent Campaign Doesn't Contain:
                        </InputLabel>
                        <Select
                          data-test="Most_Recent_Campaign__c_Name"
                          value={this.state.Most_Recent_Campaign__Does_Not_Contain}
                          onChange={this.handleChange}
                          name="Most_Recent_Campaign__Does_Not_Contain"
                          multiple
                        >
                          <MenuItem value={"All"}>None</MenuItem>
                          {this.props.funnelFilters !== "" &&
                            this.props.funnelFilters.Most_Recent_Campaign__Does_Not_Contain.map((y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

          
            {/* ACV and GO */}
            <Grid
              container
              item
              style={{ marginBottom: 10, padding: 10 }}
              justify="space-between"
              xs={4}
              lg={2}
            >
              <Grid item xs={4} xl={3} container justify="flex-end">
                <Button
                  data-test="go"
                  disabled={
                    this.state.xAxisError !== "" ||
                    this.state.yAxisError !== "" ||
                    this.state.acvError !== ""
                  }
                  variant="contained"
                  color="primary"
                  onClick={this.handleGo}
                >
                  GO
                </Button>
              </Grid>
            </Grid>
          </>
        ) : (
          <Grid
            item
            container
            component={Card}
            style={{ margin: "1rem" }}
            justify="center"
          >
            <Skeleton
              variant="react"
              animation="wave"
              height={120}
              width="90%"
              style={{ margin: "1rem" }}
            />
          </Grid>
        )}


             {this.props.funnelFilters ? (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    id="grid-container"
                    style={{
                      marginTop: "1rem",
                    //   marginLeft: "1.8rem",
                    //   marginRight: "1.8rem",
                    }}
                  >
                    <Paper style={{ marginBottom: "-7px" }}>
                      <ToggleButtonGroup
                        color="primary"
                        indicatorColor="primary"
                        value={this.state.tab}
                        exclusive
                        size="large"
                        onChange={this.handleChangeTab}
                      >
                        <ToggleButton
                          style={{
                            background: this.state.tab === "MQL" ? "#4472C4" : "",
                            color: this.state.tab === "MQL" ? "white" : "",
                            fontSize: "1rem",
                            fontWeight: 600,
                            height: "3.5rem",
                            width: "20rem",
                          }}
                          value="MQL"
                        >
                          MQL
                        </ToggleButton>
                        <ToggleButton
                          style={{
                            background: this.state.tab === "Hand_Raisers" ? "#4472C4" : "",
                            color: this.state.tab === "Hand_Raisers" ? "white" : "",
                            fontSize: "1rem",
                            fontWeight: 600,
                            height: "3.5rem",
                            width: "20rem",
                          }}
                          value="Hand_Raisers"
                        >
                          Hand Raisers
                        </ToggleButton>
                      
                       
                      </ToggleButtonGroup>
                    </Paper>
                  </Grid>
                ) : (
                  <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                    <Grid item container justify="center">
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={20}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  </Card>
                )}

        <Grid
          item
          xs={12}
          className={classes.grid}
          container
          justify="center"
          style={{ marginTop: "1rem" }}
        >
          <Grid
            item
            xs={12}
            style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
          >
           
              {this.props.funnelData !== "" ? ( 
                <>
                 <Card style={{ margin: "auto", width: "100%", marginBottom: '1rem'}} raised={true}>
                <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="h2"
                      style={{
                        margin: "1rem",
                        display: "flex",
                        justifyContent: "center",
                        padding: "1rem",
                      }}
                    >
                      {/* ACV Pursued, Won, Win Rate, Open Pipeline */}

                     By {this.state.tab === 'Hand_Raisers' ? 'Hand Raisers' : 'MQL'}

                     
                    </Typography>
                  </Grid>
                  <Grid item xs={1} style={{ marginTop: "2rem" }}>
                   
                  </Grid>
                  
                  <DataTable 
                      uniqueTimeframes={this.props.funnelData.uniqueTimeFrames} 
                      data={this.props.funnelData.data} 
                      dataTest={`data-test-MQL`}
                       uniqueRegions={this.props.funnelData.uniqueRegions}
                       handleChangeLocation={this.handleChangeLocation}
                    quarters={this.props.funnelData.timeFrameType}
                     />
                 
                </Grid>
                </Card>
                </>
                
                
              ) : (
                <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                <Grid item container justify="center">
                  <Skeleton
                    variant="react"
                    animation="wave"
                    height={120}
                    width="90%"
                    style={{ margin: "1rem" }}
                  />
                </Grid>
                </Card>
              )}
            
          </Grid>
        </Grid>

        

        {this.state.location === "drilldownOnGraph" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={this.state.header}
              back={this.handleChangeLocationBack}
              filters={this.state.drilldownFilters}
            >
              <Drilldown
                header={this.state.header}
                body={this.props.drilldownOnGraphData}
                company={this.props.company}
                Value_Label={this.props.Value_Label}
                // handleSecondLevelDrilldown={this.handleSecondLevelDrilldown}
              />
            </SingleLevelDrilldown>
          </Grid>
        )}
        {this.state.secondLevelLocation === "drilldownOppId" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={"Opportunity Change Events"}
              back={this.handleChangeLocationBack}
              stepBack={this.stepBack}
              filters={[]}
            >
              <ExpectedAcvPage
                Value_Label={this.props.Value_Label}
                body={this.props.ExpectedAcvData}
              />
            </SingleLevelDrilldown>
          </Grid>
        )}
      </Grid>
    );
  }
}

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      // prefix="$"
      allowNegative={false}
    />
  );
}

function mapStateToProps(state) {
  const {
    funnelFilters,
    funnelData,
    persistentAlert,
    user,
    drilldownOnGraphData,
    updatingFunnelData,
    updatingDrillDownData,
    currentFilters,
    ExpectedAcvData,
  } = state.app;

  return {
    funnelFilters,
    funnelData,
    persistentAlert,
    company: user.company,
    Value_Label: user.Value_Label,
    Win_Rate_Prefix: user.Win_Rate_Prefix,
    Currency_Symbol: user.Currency,
    drilldownOnGraphData,
    updatingFunnelData,
    updatingDrillDownData,
    currentFilters,
    ExpectedAcvData,
  };
}

const mapDispatchToProps = (dispatch) => ({
  getFunnelFilters: (company) => {
    dispatch({ type: "get_funnel_filters_request" });
    appService.getMQLandHandRaisersFilters().then(
      (json) => {
        dispatch({ type: "get_funnel_filters_success", json });
        dispatch({ type: "get_funnel_data_request" });
        const defaultFiscalQuarter = json.message.defaultFiscalQuarter
        const deafaultLeadSource = json.message.deafaultExclude_LeadSource
        const defaultMostRecentCampaignDoesNotContain = json.message.defaultMost_Recent_Campaign_Does_Not_Contain

        const defaultInternalTorq = json.message.defaultInternal_Torq_Record__c

        let filters = [];
        if (defaultFiscalQuarter && defaultFiscalQuarter.length > 0) {
          filters = [
            { name: "MQL_Fiscal_Quarter", value: defaultFiscalQuarter },
          ];
        }

        if(deafaultLeadSource && deafaultLeadSource.length > 0){
            filters = [
                ...filters,
                { name: "Exclude_LeadSource", value: deafaultLeadSource },
              ];
        }

        if(defaultInternalTorq){
            filters = [
                ...filters,
                { name: "Internal_Torq_Record__c", value: defaultInternalTorq },
              ];
        }

        if(defaultMostRecentCampaignDoesNotContain.length > 0){
            filters = [
                ...filters,
                {name: 'Most_Recent_Campaign__Does_Not_Contain', value: defaultMostRecentCampaignDoesNotContain}
            ]
        }

        
        

        appService.getMQLandHandRaisersData(filters).then(
          (json) => {
            dispatch({ type: "get_funnel_data_success", json });
          },
          (error) => {
            if (typeof error === "object")
              dispatch({
                type: "get_funnel_data_failure",
                error: "Something went wrong",
              });
            else dispatch({ type: "get_funnel_data_failure", error });
          }
        );
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_funnel_filters_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_funnel_filters_failure", error });
      }
    );
  },
  getFunnelDataNew: (filters) => {
    dispatch({ type: "get_funnel_data_request" });
    dispatch({ type: "current_selected_filters", filters });
    appService.getMQLandHandRaisersData(filters).then(
      (json) => {
        dispatch({ type: "get_funnel_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_funnel_data_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_funnel_data_failure", error });
      }
    );
  },
  getWinACVDrilldown: (filters, meta) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getWinAcvMixAnalysisdrilldown(filters, meta).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].map(
          (item, index) => {
            let x = {
              ...item,
              OppNo: index + 1,
            };
            return x;
          }
        );

        tempOpportunities.sort((a, b) => (a.ACV > b.ACV ? -1 : 1));

        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json = {
          ...json,
          message: {
            ...json.message,
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
            columns: json.message.columns,
          },
        };
        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  getDemandGenDrilldown: (filters, key1, key2) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getDemandGenDrilldown(filters, key1, key2).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].map(
          (item, index) => {
            let x = {
              ...item,
              OppNo: index + 1,
            };
            return x;
          }
        );

        tempOpportunities.sort((a, b) => (a.ACV > b.ACV ? -1 : 1));

        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json = {
          ...json,
          message: {
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
            columns: json.message.columns,
          },
        };
        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  getPipelineMixDrilldown: (filters) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getMQLandHandRaisersDrilldown(filters).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].map(
          (item, index) => {
            let x = {
              ...item,
              //closed_date: item.closed_date !== undefined ? item.closed_date.split('T')[0] : item.projected_close_date.split('T')[0],
              OppNo: index + 1,
            };
            return x;
          }
        );

        tempOpportunities.sort((a, b) => (a.ACV > b.ACV ? -1 : 1));

        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json = {
          ...json,
          message: {
            ...json.message,
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
            columns: json.message.columns,
          },
        };
        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  clearDrilldownData: () => {
    dispatch({ type: "clear_drilldown_data" });
  },
  getOpenOppData: (oppId) => {
    dispatch({ type: "get_expectedAcv_drilldown_data_request" });
    appService.getWaterfallOppData(oppId).then(
      (json) => {
        dispatch({ type: "get_expectedAcv_drilldown_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_expectedAcv_drilldown_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({ type: "get_expectedAcv_drilldown_data_failure", error });
      }
    );
  },
  clearExpectedAcvData: () => {
    dispatch({ type: "clear_expected_acv_data" });
  },
});
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f5f5f5",
    },
  },
}))(TableRow);

const connectedMQLandHandRaisers = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MQLandHandRaisers));
export { connectedMQLandHandRaisers as MQLandHandRaisers };
